// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-1eM8VHV_","sider":"sider-23B0EWrV","ipad_sider":"ipad_sider-fyacVNCn"};